import { render, staticRenderFns } from "./ShopItem.vue?vue&type=template&id=1d6deb9e&scoped=true&"
import script from "./ShopItem.vue?vue&type=script&lang=js&"
export * from "./ShopItem.vue?vue&type=script&lang=js&"
import style0 from "./ShopItem.vue?vue&type=style&index=0&id=1d6deb9e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d6deb9e",
  null
  
)

export default component.exports